export default {
  formId: "organization-form",
  formField: {
    organizationKey: {
      name: "organizationKey",
      label: "Organization Title",
      type: "text",
      placeholder: "eg. ORG_TITLE",
      size: "large",
      errorMsg: "Organization Title is required.",
    },
    isPhonicsEnabled: {
      name: "isPhonicsEnabled",
      label: "Enable Phonics Feature",
      type: "switch",
    },
  },
};
